<template>
    <b-modal :active="true" :canCancel="['escape']" has-modal-card>
        <component :is="currentComponent" @hide="close" />
    </b-modal>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';

    import {
        STEP_ONE,
        STEP_TWO,
        STEP_THREE,
        SET_PROJECT_STUDENT,
        SET_PROJECT_STEP,
        SET_PROJECT_CUSTOMER,
        SET_PROJECT_CUSTOMER_STATUS,
        RESET_PROJECT,
        LOGGED_IN,
    } from '@/taskflex/students/store/contactForm/_types';
    import StepOne from '@/taskflex/students/components/contact/StepOne';
    import StepTwo from '@/taskflex/students/components/contact/StepTwo';
    import StepThree from '@/taskflex/students/components/contact/StepThree';

    export default {
        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'isCustomer',
                'currentUserAccount',
            ]),

            ...mapGetters('contactForm', [
                'currentStep',
            ]),

            currentComponent() {
                return this.$options.componentSteps[this.currentStep];
            },
        },

        componentSteps: {
            [STEP_ONE]: 'step-one',
            [STEP_TWO]: 'step-two',
            [STEP_THREE]: 'step-three',
        },

        mounted() {
            this.resetProject();
            this.setStudent(this.student);

            // Check for logged-in customer
            if (this.isCustomer && this.currentUserAccount) {
                this.setCustomer(this.currentUserAccount);
                this.setCustomerStatus(LOGGED_IN);
            }

            this.setStep(STEP_ONE);
        },

        methods: {
            ...mapMutations('contactForm', {
                resetProject: RESET_PROJECT,
                setStep: SET_PROJECT_STEP,
                setStudent: SET_PROJECT_STUDENT,
                setCustomer: SET_PROJECT_CUSTOMER,
                setCustomerStatus: SET_PROJECT_CUSTOMER_STATUS,
            }),

            close() {
                this.$emit('hide');
            },
        },

        components: {
            StepOne,
            StepTwo,
            StepThree,
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/contact/ContactModal.vue